# for older versions of backbone, we need to assign jQuery object
Backbone = require 'backbone'
Backbone.$ = window.$
window.Backbone = require "backbone"
